module.exports = __webpack_public_path__ + "static/media/run.2e52fdcb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/run.svg
// module id = 98
// module chunks = 0